export const CF_API_URL =
  import.meta.env.VITE_CF_API_URL ||
  window.__ORDERCUS_CF_API_URL ||
  'https://asia-southeast1-srikanett-order.cloudfunctions.net/ordercusApi'

export const BEAM_CHARGE_URL =
  import.meta.env.VITE_BEAM_CHARGE_URL ||
  'https://asia-southeast1-srikanett-order.cloudfunctions.net/createBeamCharge'

export const MEMBER_API_URL =
  import.meta.env.VITE_MEMBER_API_URL ||
  'https://asia-southeast1-srikanett-order.cloudfunctions.net/memberApi'

export const SHOP_CATALOG_URL =
  import.meta.env.VITE_SHOP_CATALOG_URL ||
  'https://asia-southeast1-srikanett-order.cloudfunctions.net/shopCatalog'

export const LIFF_ID_BOT1 = '2008655508-r8W209qQ'
export const LIFF_ID_BOT2 = '2009352737-Kp9DAzYW'

export const GANESHA_LOGO =
  'https://lh3.googleusercontent.com/d/1CKvxL04Ou6WS1Y7uc3L3sdfsGvGmb5JU'

/** โลโก้วิดีโอ 3D ส่วนหัว — ไฟล์บีบอัดใน public/ (~86KB) */
export const GANESHA_LOGO_VIDEO = '/ganesha-logo.mp4'
export const GANESHA_LOGO_POSTER = '/ganesha-logo-poster.jpg'

/** ภาพพระพิฆเนศตอนรอโหลดหน้าแรก (ตามต้นฉบับ index.html) */
export const GANESHA_LOADER =
  'https://img2.pic.in.th/IMG_06044a3e4210827d82f0.png'

export const LINE_CONTACT_BOT1 = 'https://lin.ee/USKyQQg'
export const LINE_CONTACT_BOT2 = 'https://lin.ee/WEebb9c'
export const LINE_ID_BOT1 = '@sriganett99'
export const LINE_ID_BOT2 = '@srikanett'

/** คีย์เวิร์ดติดต่อทีมงานจากหน้าสมาชิก */
export const LINE_ADMIN_KEYWORD = 'ติดต่อคุณดริว/แอดมิน'

/** @deprecated use getLineContact(botId) */
export const LINE_CONTACT = LINE_CONTACT_BOT1

export const HEALTH_CHECK_URL =
  'https://asia-southeast1-srikanett-order.cloudfunctions.net/healthCheck'
